import createAction from '../../../utils/redux-helpers/createAction';

const handler = (state, { error }) =>
  state.setIn(['modals', 'error'], true).setIn(['error'], error);

export const setError = createAction({
  action: ['setError', 'error'],
  handler,
});
